import '../styles/GlobalDesign.css';
import React from 'react';
import { Link } from 'react-router-dom';

const HowItWorks = () => {
  return (
    <div className="home-container">
      {/* Navbar identique à la page d'accueil */}
      <nav className="navbar">
        <div className="navbar-brand">
          <Link to="/">
            <img 
              src="/logo.png"
              alt="Fluxivo Logo" 
              className="navbar-logo"
            />
            <span className="logo">Flux<span style={{color:'#22C55E'}}>ivo</span></span>
          </Link>
        </div>
        <div className="nav-links">
          <Link to="/">Accueil</Link>
          <Link to="/how-it-works" className="active">Comment ça marche</Link>
          <Link to="/privacy">Confidentialité</Link>
        </div>
      </nav>

      {/* Contenu de la page */}
      <div className="legal-page-content">
        <div className="legal-container">
          <h1>Comment ça marche ?</h1>
          <p className="intro">
            Découvrez comment profiter de Fluxivo en quelques étapes simples.
          </p>

          <section className="step-section">
            <div className="step-number">1</div>
            <h2>Choisissez votre abonnement</h2>
            <p>
              Sélectionnez la durée qui vous convient parmi nos différentes formules : 
              1 mois, 3 mois ou 1 an. Tous nos abonnements donnent 
              accès à l'intégralité de nos chaînes en qualité HD et Full HD.
            </p>
            <div className="highlight-box">
              <h4>📺 +20,000 chaînes disponibles</h4>
              <ul>
                <li>Sport : BeIN Sports, Canal+ Sport, RMC Sport...</li>
                <li>Films & Séries : Canal+, Netflix, Prime...</li>
                <li>Divertissement : TF1, France 2, M6...</li>
                <li>Enfants : Disney Channel, Gulli...</li>
                <li>Documentaires : National Geographic, Discovery...</li>
              </ul>
            </div>
          </section>

          <section className="step-section">
            <div className="step-number">2</div>
            <h2>Remplissez le formulaire</h2>
            <p>
              Indiquez vos informations de contact : nom, email et numéro de téléphone. 
              Ces informations sont nécessaires pour traiter votre commande et vous envoyer 
              vos identifiants.
            </p>
          </section>

          <section className="step-section">
            <div className="step-number">3</div>
            <h2>Effectuez le paiement</h2>
            <p>
              Payez en toute sécurité via MoneyFusion avec :
            </p>
            <ul>
              <li>🏦 Mobile Money (Orange Money, MTN, Moov...)</li>
              <li>💳 Carte bancaire</li>
              <li>💵 Autres moyens de paiement locaux</li>
            </ul>
            <p>
              Le paiement est 100% sécurisé et vos données bancaires ne sont jamais stockées.
            </p>
          </section>

          <section className="step-section">
            <div className="step-number">4</div>
            <h2>Recevez votre lien M3U</h2>
            <p>
              Dès la validation de votre paiement, vous recevez instantanément :
            </p>
            <ul>
              <li>✅ Votre lien M3U personnalisé affiché sur la page</li>
              <li>📧 Le même lien envoyé par email</li>
            </ul>
            <div className="info-box">
              <strong>💡 Qu'est-ce qu'un lien M3U ?</strong>
              <p>
                C'est un lien unique qui contient la liste de toutes vos chaînes. 
                Il suffit de le copier et de le coller dans votre application IPTV 
                pour accéder à tout le contenu.
              </p>
            </div>
          </section>

          <section className="step-section">
            <div className="step-number">5</div>
            <h2>Installez votre application IPTV</h2>
            <p>
              Téléchargez une application compatible sur votre appareil :
            </p>
            
            <div className="apps-grid">
              <div className="app-card">
                <h4>📱 Smartphone & Tablette</h4>
                <ul>
                  <li>IPTV Smarters Pro (recommandé)</li>
                  <li>GSE Smart IPTV</li>
                  <li>TiviMate</li>
                </ul>
              </div>

              <div className="app-card">
                <h4>📺 Smart TV</h4>
                <ul>
                  <li>Smart IPTV</li>
                  <li>IPTV Smarters Pro</li>
                  <li>SS IPTV</li>
                </ul>
              </div>

              <div className="app-card">
                <h4>💻 Ordinateur</h4>
                <ul>
                  <li>VLC Media Player</li>
                  <li>IPTV Smarters Pro</li>
                  <li>MyIPTV Player</li>
                </ul>
              </div>

              <div className="app-card">
                <h4>🎮 Box & Console</h4>
                <ul>
                  <li>Amazon Fire Stick</li>
                  <li>Android TV Box</li>
                  <li>Apple TV</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="step-section">
            <div className="step-number">6</div>
            <h2>Configurez et profitez !</h2>
            <p>Dans votre application IPTV :</p>
            <ol>
              <li>Ouvrez l'application</li>
              <li>Sélectionnez "Ajouter une playlist" ou "Add Playlist"</li>
              <li>Choisissez "M3U URL" ou "URL"</li>
              <li>Collez votre lien M3U reçu par email</li>
              <li>Validez et patientez quelques secondes</li>
              <li>🎉 Toutes vos chaînes sont maintenant disponibles !</li>
            </ol>
          </section>

          <section className="faq-section">
            <h2>Questions fréquentes</h2>
            
            <div className="faq-item">
              <h3>❓ Puis-je utiliser mon abonnement sur plusieurs appareils ?</h3>
              <p>
                Oui ! Votre lien M3U peut être utilisé sur plusieurs appareils simultanément. 
                Regardez la TV sur votre smartphone, tablette, ordinateur ou Smart TV.
              </p>
            </div>

            <div className="faq-item">
              <h3>❓ Que se passe-t-il si j'ai un problème ?</h3>
              <p>
                Notre équipe support est disponible par email à <strong>support@fluxivo.com</strong>. 
                Nous répondons généralement sous 24h.
              </p>
            </div>

            <div className="faq-item">
              <h3>❓ La qualité est-elle bonne ?</h3>
              <p>
                Oui ! Toutes nos chaînes sont diffusées en HD et Full HD selon votre connexion internet. 
                Nous recommandons une connexion d'au moins 5 Mbps pour une expérience optimale.
              </p>
            </div>

            <div className="faq-item">
              <h3>❓ Mon abonnement se renouvelle-t-il automatiquement ?</h3>
              <p>
                Non, il n'y a aucun renouvellement automatique. Vous gardez le contrôle total 
                et pouvez renouveler quand vous le souhaitez.
              </p>
            </div>
          </section>

          <div className="cta-section">
            <h2>Prêt à commencer ?</h2>
            <p>Choisissez votre abonnement et profitez de Fluxivo dès maintenant !</p>
            <Link to="/" className="cta-button">
              🚀 Voir les abonnements
            </Link>
          </div>
        </div>
      </div>

      {/* Footer identique à la page d'accueil */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">Fluxivo</div>
            <p>Service de streaming IPTV Premium</p>
          </div>
          <div className="footer-section">
            <h4>Liens rapides</h4>
            <a href="/">Accueil</a>
            <a href="/how-it-works">Comment ça marche</a>
            <a href="/privacy">Confidentialité</a>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>support@fluxivo.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Fluxivo. Tous droits réservés.</p>
          <p>+20,000 chaînes • Qualité HD/4K • Support 24/7</p>
        </div>
      </footer>
    </div>
  );
};

export default HowItWorks;
